import { Component, Input, ViewChild, ComponentFactoryResolver, Output, EventEmitter, } from '@angular/core';
import { DynamicComponentDirective } from '../../../directives/dynamic.component.directive';
import { ComponentMount } from '../../component.mount';
import { S3AlbumComponentIonic } from './s3-album.component.ionic';
import { S3AlbumComponentCore } from './s3-album.component.core';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../../../directives/dynamic.component.directive';

function S3AlbumComponent_ng_template_3_Template(rf, ctx) { }
var S3AlbumComponent = /** @class */ (function () {
    function S3AlbumComponent(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.selected = new EventEmitter();
    }
    S3AlbumComponent.prototype.ngOnInit = function () {
        this.loadComponent();
    };
    S3AlbumComponent.prototype.ngOnDestroy = function () { };
    S3AlbumComponent.prototype.loadComponent = function () {
        var _this = this;
        var albumComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(S3AlbumComponentIonic, {
                path: this.path,
                options: this.options,
            })
            : new ComponentMount(S3AlbumComponentCore, {
                path: this.path,
                options: this.options,
            });
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(albumComponent.component);
        var viewContainerRef = this.componentHost.viewContainerRef;
        viewContainerRef.clear();
        var componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = albumComponent.data;
        componentRef.instance.selected.subscribe(function (e) {
            _this.selected.emit(e);
        });
    };
    /** @nocollapse */
    S3AlbumComponent.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
    ]; };
    S3AlbumComponent.propDecorators = {
        "framework": [{ type: Input },],
        "path": [{ type: Input },],
        "options": [{ type: Input },],
        "selected": [{ type: Output },],
        "componentHost": [{ type: ViewChild, args: [DynamicComponentDirective,] },],
    };
S3AlbumComponent.ɵfac = function S3AlbumComponent_Factory(t) { return new (t || S3AlbumComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
S3AlbumComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: S3AlbumComponent, selectors: [["amplify-s3-album"]], viewQuery: function S3AlbumComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DynamicComponentDirective, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.componentHost = _t.first);
    } }, inputs: { framework: "framework", path: "path", options: "options" }, outputs: { selected: "selected" }, decls: 6, vars: 0, consts: [["component-host", ""]], template: function S3AlbumComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n\t\t");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵtext(2, "\n\t\t\t");
        ɵngcc0.ɵɵtemplate(3, S3AlbumComponent_ng_template_3_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵtext(4, "\n\t\t");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\n\t");
    } }, directives: [ɵngcc1.DynamicComponentDirective], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(S3AlbumComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-album',
                template: "\n\t\t<div>\n\t\t\t<ng-template component-host></ng-template>\n\t\t</div>\n\t"
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, { selected: [{
            type: Output
        }], framework: [{
            type: Input
        }], path: [{
            type: Input
        }], options: [{
            type: Input
        }], componentHost: [{
            type: ViewChild,
            args: [DynamicComponentDirective]
        }] }); })();
    return S3AlbumComponent;
}());
export { S3AlbumComponent };

